//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import { RQ } from 'utils';
import * as F from 'utils/F';
import { dateFormat } from 'utils/filters';
import { yoButton, LoadMore, NavBar } from 'components';
import action from './action';
import {
  Tag,
  Row,
  Col,
  Cell,
  CellGroup,
  Swipe,
  SwipeItem,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  Tab,
  Tabs,
  Rate,
  Popup,
  Actionsheet,
  RadioGroup,
  Radio,
  Button,
  Checkbox
} from 'vant';

export default {
  name: 'coupon',
  props: ['params'],
  metaInfo: {
    title: '开通超级会员'
  },
  created: async function () {
    this.getMemberSet();
    this.getTipInfo();
  },
  updated() {
    // console.log(this.popupVisible1);
    console.log('data ---> ', this.data);
  },
  data() {
    // const tipInfo = JSON.parse(localStorage.getItem('tipInfo'));
    // var tipDetail = '';
    // if(tipInfo.tipMsg){
    //   tipDetail = tipInfo.tipMsg.replace(/\n/g, "<br/>")
    // }
    return {
      data: {},
      thumb: '../../static/img/SVIP.png',
      popupVisible1: false,
      radio: '1',
      renewPopup: false,
      tipInfo: {},
      tipDetail: ''
    };
  },
  computed: {},
  filters: {
    dateFormat
  },
  components: {
    yoButton,
    NavBar,
    Tag,
    Row,
    'van-col': Col,
    Cell,
    CellGroup,
    Swipe,
    SwipeItem,
    GoodsAction,
    GoodsActionBigBtn,
    GoodsActionMiniBtn,
    Tab,
    Tabs,
    Rate,
    'van-popup': Popup,
    Actionsheet,
    RadioGroup,
    Radio,
    'van-button': Button,
    'van-checkbox': Checkbox
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/vip/pay/page.vue